import { Box, Flex, Text, useColorModeValue, Tooltip } from '@chakra-ui/react';
import { COLOR_PRESETS } from './exportDefaults';

export const ColorPresets = ({ label, type, selectedColor, onSelect }) => {
  const labelColor = useColorModeValue('gray.600', 'gray.400');
  const presets = COLOR_PRESETS[type] || COLOR_PRESETS.primary;

  return (
    <Box>
      <Text fontSize="sm" fontWeight="500" color={labelColor} mb={2}>
        {label}
      </Text>
      <Flex gap={2} flexWrap="wrap">
        {presets.map((preset) => (
          <Tooltip key={preset.value} label={preset.name} placement="top" hasArrow>
            <Box
              w="32px"
              h="32px"
              borderRadius="md"
              bg={preset.value}
              cursor="pointer"
              border="3px solid"
              borderColor={selectedColor === preset.value ? 'white' : 'transparent'}
              boxShadow={selectedColor === preset.value ? `0 0 0 2px ${preset.value}` : 'none'}
              transition="all 0.2s"
              _hover={{
                transform: 'scale(1.1)',
                boxShadow: `0 2px 8px ${preset.value}66`,
              }}
              onClick={() => onSelect(preset.value)}
            />
          </Tooltip>
        ))}
      </Flex>
    </Box>
  );
};
